import { memo } from 'react';
import { Flex, tokens } from '@optiaxiom/react';

import * as styles from './NodeIcon.css';

type NodeIconProps = {
  Icon?: React.ComponentType<{ size?: string | number }>;
  color?: keyof typeof tokens.colors;
  nodeType: string;
  category?: string;
  variant?: 'condition';
};

export const NodeIcon = memo(({ Icon, color, nodeType, category, variant }: NodeIconProps) => {
  if (!Icon) {
    console.warn(`No icon component provided for node type: ${nodeType}`);
    return null;
  }

  const iconClassName =
    variant === 'condition'
      ? styles.nodeIconCondition
      : category === 'trigger'
        ? styles.nodeIcon
        : styles.nodeIconStep;

  return (
    <Flex className={iconClassName} style={color ? { color: tokens.colors[color] } : undefined}>
      <Icon />
    </Flex>
  );
});

NodeIcon.displayName = 'NodeIcon';
